import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";
import { useNavigate,useLocation, useSearchParams } from "react-router-dom";
import { CustomLoader } from "src/components";
import classes from "src/components/Welcome/Welcome.module.scss";
import { useFormContext } from "src/context/Form/form-context";
import { AllFormNames } from "../../../constants/form-names-constants";
import React, { useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { settingsService } from "src/services/settings.service";
import{addNewBppFormRequestRenditionExtension,getBPPPropertySearchSettings} from  "../../../api/form-entries-api";
import type { AxiosError, AxiosResponse } from "axios";
import {setLoading, temporaryError,temporarySuccessMessage} from "src/context/shared/shared-context.helper";
import AuthService from 'src/services/authentication.service';
 import Cookies from "js-cookie";
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
 
import PropertySearchPopup from 'src/components/Welcome/components/PropertySearchPopup';
import { YearViewService } from "@progress/kendo-react-dateinputs/dist/npm/calendar/services";
export default function FormList(): JSX.Element {
  const { formState ,formDispatch} = useFormContext();

  const { t } = useTranslation();
  const navigate = useNavigate();
   const [searchParams] = useSearchParams();
 const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedForm, setSelectedForm] = useState<{ id: number; name: string } | null>(null);
  const [radioValue, setRadioValue] = useState<'opt1' | 'opt2' |''>('opt1');
   const [isLoading, setIsLoading] = useState<boolean>();
   const [apiResponse, setApiResponse] = useState<any>(null);
  const settings = settingsService().settings;
  const year =settings.onlineFormsYear
  const { isAuthorized } = AuthService.getInstance();
  function openForm(id: number, name: string) {
     if ((name === "BPP" || name ==="HomesteadExemption") && isAuthorized && settings.isHarrisClient && !settings.enableFormsOnlyLogin) {
      setSelectedForm({ id, name });
      //setDialogVisible(true);
      setShowPropertyDialog(true);
       
      setIsLoading(false);
    } else if (AllFormNames.includes(name)) {
      navigate(`/home/forms/${name}`);
    } else {
      navigate(`/home/forms/${id}`);
    }
  }
const onOk = async () => {
    if (!selectedForm) return;
    const { id, name } = selectedForm;
    
    // perform navigation or logic based on the selected radio
    if (radioValue === 'opt1') {
      navigate(`/home/forms/${name}`);
      
    } else  if (radioValue === 'opt2' && !apiResponse) {
       setIsLoading(true);
       
       const propertyId = searchParams.get("propertyId") != null?searchParams.get("propertyId") :Cookies.get('propertyId');
          const yearString = searchParams.get("year")!= null?searchParams.get("year") :Cookies.get('year');
          const ownerId = searchParams.get("ownerId")!= null?searchParams.get("ownerId") :Cookies.get('ownerId');
           
            setDialogVisible(false);
             try {
    const getPropertySettingAPI = await getBPPPropertySearchSettings(
        propertyId!,
        parseInt(yearString!),
        ownerId!,
        selectedForm.id
      ); 
      setApiResponse(null);
    

     const submitRenditionExtension = await addNewBppFormRequestRenditionExtension(
        propertyId!,
        parseInt(yearString!),
        ownerId!,
        getPropertySettingAPI.data
      );
      setApiResponse(submitRenditionExtension.data);   
      setDialogVisible(true);      
      setRadioValue('');
      setIsLoading(false);
    }catch (error) {
      const axiosError = error as AxiosError;
      setApiResponse("Error");
      setDialogVisible(true);
      setRadioValue('');
       setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
    }
        else {
  setDialogVisible(false);
  setApiResponse(null);
  setRadioValue('opt1'); 
}
  };
 const errorProcessing = (errorMessage?: string | unknown) => {
     
  };
  const onCancel = () => {
    setDialogVisible(false);
    setSelectedForm(null);
     setRadioValue('opt1'); 
     setApiResponse(null);
  };
  const [showPropertyDialog, setShowPropertyDialog] = useState(false);
  return (
    <div className={classes.FormContent}>
      <span className={classes.GetStarted}>
        {t("welcomePart.chooseForm")}
         {/* {isAuthorized &&(
           
      <button onClick={() => setShowPropertyDialog(true)} className="search-button">
      <FontAwesomeIcon icon={faMagnifyingGlass} size="lg" />
    </button>)
  } */}
      </span>
      
      <div className={classes.FormList}>
        {formState.loading && <CustomLoader />}

        {!formState.loading &&
          formState.forms &&  !showPropertyDialog &&
          formState.forms.map((form) => {
            return (
              <div key={form.id} className={classes.Form}>
                <Button onClick={() => openForm(form.id, form.name)}>
                  <FontAwesomeIcon className="mr-2" icon="file" />
                  <span>{form.displayName}</span>
                </Button>
              </div>
            );
          })}
      </div>
     
   <PropertySearchPopup formName={selectedForm?.name} showPopup={showPropertyDialog} onClose={() => setShowPropertyDialog(false)}  onPropertySelect={() => {
    setShowPropertyDialog(false);
    if(selectedForm?.name ==="BPP" && !settings.allowBPPFormExtensionRequests)
    {
      navigate(`/home/forms/${selectedForm.name}`);
    }
    else if(selectedForm?.name ==="BPP" && !settings.enableFormsPACSIntegration)
    {
      navigate(`/home/forms/${selectedForm.name}`);
    }
    if (selectedForm?.name === "HomesteadExemption") {
       navigate(`/home/forms/${selectedForm.name}`);
    }
    else{
    setDialogVisible(true);
    }
  }}/>
  
       {isLoading && <CustomLoader />}
       {dialogVisible  && !showPropertyDialog &&(
        <Dialog title={t("welcomePart.confirmBPP")} onClose={onCancel}>
           {!apiResponse && (
          <div style={{ padding: '1rem' }}>
            <div>
              <label>
                <input
                  type="radio"
                  name="bppChoice"
                  value="opt1"
                  checked={radioValue === 'opt1'}
                  onChange={() => setRadioValue('opt1')}
                />
                {t("welcomePart.option1")} {year}
              </label>
            </div>
            <div style={{ marginTop: '0.5rem' }}>
              <label>
                <input
                  type="radio"
                  name="bppChoice"
                  value="opt2"
                  checked={radioValue === 'opt2'}
                  onChange={() => setRadioValue('opt2')}
                />
                {t("welcomePart.option2")} {year}
              </label>
            </div>
          </div>
           )}
     
     {apiResponse && (
  <div className="space-between">
    {apiResponse.error ? (
      <div>Error: {apiResponse.error}</div>
    ) : (
      <div
        className={classes.TextPrimary}
        dangerouslySetInnerHTML={{ __html: apiResponse }}
      />
    )}
  </div>
)}
          <DialogActionsBar>
            <Button onClick={onCancel}>
              {t("welcomePart.cancel")}
            </Button>
            <Button themeColor="primary" onClick={onOk}>
              {t("welcomePart.ok")}
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
}
